import { inject } from "vue";
import { ActivityState } from "../types";
import { useContext } from "@/store/context";
import { storeToRefs } from "pinia";
export const useActivities = (i18n) => {
    if (!i18n) {
        i18n = inject("i18n");
    }
    const context = useContext();
    const { currentLocale } = storeToRefs(context);
    const taskOptionsFn = (activities, dependents, focusActivityId = -1, taskMapper) => {
        const t = _activityOptionsFn(activities, dependents, true, true, focusActivityId, taskMapper);
        return t;
    };
    const activityOptionsFn = (activities, dependents, evalTasksVis = true, focusActivityId = -1) => {
        return _activityOptionsFn(activities, dependents, false, evalTasksVis, focusActivityId);
    };
    const _activityOptionsFn = (activities, dependents, includeSubOptions, evalTasksVis, focusActivityId = -1, taskMapper) => {
        const response = Object.values(ActivityState).flatMap((state) => {
            return {
                header: activityStateHeader(state),
                options: activities
                    ?.filter((a) => a.state == state && a.tasks && a.id != focusActivityId)
                    .map((a) => {
                    return {
                        name: a.name,
                        id: a.id,
                        subText: getDateRange(a.dateStart, a.dateEnd),
                        subOptions: includeSubOptions && getTasks(a, taskMapper, dependents),
                        disabled: !visibleActivity(a, dependents, includeSubOptions || (evalTasksVis ?? false))
                    };
                })
                    .filter((a) => !includeSubOptions || a.subOptions?.length != 0)
            };
        });
        // Current focus activity
        const currentActivity = activities
            ?.filter((a) => a.tasks && a.id == focusActivityId)
            .map((a) => {
            return {
                name: a.name,
                id: a.id,
                subText: getDateRange(a.dateStart, a.dateEnd),
                subOptions: includeSubOptions && getTasks(a, taskMapper, dependents),
                disabled: !visibleActivity(a, dependents, includeSubOptions || (evalTasksVis ?? false))
            };
        })
            .filter((a) => !includeSubOptions || a.subOptions?.length != 0);
        if (currentActivity && currentActivity.length > 0) {
            response.unshift({
                header: i18n.t("Current"),
                options: currentActivity
            });
        }
        return response || [];
    };
    const getTasks = (activity, taskMapper, dependents) => {
        if (!activity.tasks || activity.tasks.length == 0)
            return undefined;
        const tasks = activity.tasks
            .map((task) => {
            const t = { ...task };
            t.disabled = !visibleTask(activity, t, dependents);
            return t;
        })
            .map(taskMapper
            ? taskMapper
            : (t) => {
                t.subOptions = undefined;
                return t;
            })
            .filter((t) => t != undefined);
        return tasks;
    };
    const visibleTask = (a, t, dependents) => {
        return (dependents?.find((d) => d.activityId == Number(a.id) && (d.taskId == Number(t.id) || d.taskId == -1)) == undefined);
    };
    const visibleActivity = (a, dependents, includeTasks) => {
        if (includeTasks && (a.tasks == undefined || a.tasks.length == 0)) {
            return false;
        }
        if (includeTasks) {
            return !dependents || a.tasks.find((t) => visibleTask(a, t, dependents)) != undefined;
        }
        else {
            return !dependents || dependents.find((d) => d.activityId == Number(a.id)) == undefined;
        }
    };
    const activityStateHeader = (state) => {
        return state == ActivityState.Expired
            ? i18n.t("Expired")
            : state == ActivityState.Archived
                ? i18n.t("Archived")
                : state == ActivityState.Current
                    ? i18n.t("Active")
                    : state == ActivityState.Upcoming
                        ? i18n.t("Upcoming")
                        : "";
    };
    const getDateRange = (dateStart, dateEnd) => {
        if (dateEnd == undefined || dateStart == undefined) {
            return undefined;
        }
        const options = {
            month: "short",
            day: "numeric"
        };
        const _ = { ...options };
        const prevYear = new Date(dateEnd).getFullYear() < new Date().getFullYear();
        return (new Date(dateStart).toLocaleDateString(currentLocale.value.replace("_", "-"), options) +
            " - " +
            new Date(dateEnd).toLocaleDateString(currentLocale.value.replace("_", "-"), {
                ...options,
                ...(prevYear ? { year: "numeric" } : {})
            }));
    };
    return { activityOptionsFn, taskOptionsFn };
};
